import type { ReactNode } from 'react';

interface PageHeaderProps {
  /**
   * Section name the old `Autopostmate / X` breadcrumb printed. No longer drawn —
   * the sidebar shows where you are — and kept optional so call sites need not
   * change in step.
   */
  section?: string;
  title: string;
  /** One line. Anything longer belongs in the page body, not the header. */
  lede: ReactNode;
  /**
   * Optional real system data (a job id, a time), set small and muted at the
   * right of the title row so it costs no height.
   */
  meta?: ReactNode;
}

/**
 * Shared page header: display-face headline at working size, a one-line lede,
 * hairline rule. About 90px tall, so content starts in the first viewport.
 */
export function PageHeader({ title, lede, meta }: PageHeaderProps) {
  return (
    <header className="page__header">
      <div className="page__title-row">
        <h1 className="page__title">{title}</h1>
        {meta ? <p className="page__meta">{meta}</p> : null}
      </div>
      <p className="page__lede">{lede}</p>
    </header>
  );
}
